import styles from './feature_borderless.module.scss'
import { graphql, navigate } from 'gatsby'
import PageLayout from '../components/PageLayout/PageLayout'
import FeaturesZoneRenderer from '../zones/FeaturesZoneRenderer'
import { PageHorizontalNav } from '../components/PageHorizontalNav/PageHorizontalNav'
import { Column, Container, Row } from '@algbra/ui/components/Grid/Grid'
import { VAlign } from '@algbra/ui/enums/align'
import Heading from '@algbra/ui/components/Heading/Heading'
import FreeText from '@algbra/ui/components/FreeText/FreeText'
import classNames from 'classnames'
import { StaticImage } from 'gatsby-plugin-image'
import HeaderContainerEthicalSavings from '../components/HeaderContainerEthicalSavings/HeaderContainerEthicalSavings'
import HeaderContainerBorderless from '../components/HeaderContainerBorderless/HeaderContainerBorderless'
import Footer from '../components/Footer/Footer'
import Header from '../components/Header/Header'
import MetaTags from '../components/MetaTags/MetaTags'
import { getMetaTags } from '../utils/metaTags'
import {
  MEDIA_QUERY_MOBILE,
  useMediaQuery,
} from '@algbra/ui/hooks/useMediaQuery'
import AnnouncementBar from '@algbra/ui/components/AnnouncementBar/AnnouncementBar'
import { ReactComponent as InfoIcon } from '../images/info-white.svg'
import Button from '@algbra/ui/components/Button/Button'

export default function LayoutFeaturesEthicalSavings({
  pageContext,
  data,
  location,
}) {
  const isMobile = useMediaQuery(MEDIA_QUERY_MOBILE)
  const zones = data.strapiGQL.feature.contentZones
  const title = data.strapiGQL.feature.title
  const subtitle = data.strapiGQL.feature.subtitle

  return (
    <div>
      <MetaTags {...getMetaTags(pageContext)} />
      <HeaderContainerBorderless>
        <AnnouncementBar
          title="Algbra Labs bolsters diaspora-focused digital banking leadership with Isbank and RUUT strategic partnership"
          to="/news/algbra-labs-and-moka-united-the-fintech-subsidiary-of-isbank-announce-strategic-partnership-to-launch-ruut-in-the-uk/"
          target="_self"
          category="Press Release"
          bg="light"
          textColor="white"
        />
        <Header
          hasBorder={isMobile}
          hasBg={false}
          hasAnnouncement={true}
          forceTheme="darkTranslucent"
        />

        <Container
          fluid={false}
          className={styles.zIndexed}
          role="complementary"
        >
          <Row vAlign={VAlign.CENTER} className={styles.bannerArea}>
            <Column size={12} sm={12} className={styles.content}>
              <div className={styles.textContainer}>
                <Heading level={1} type="xl" className={styles.header}>
                  {title}
                </Heading>
                <FreeText
                  className={classNames(styles.text, styles.subtitle)}
                  color="primary"
                  innerHTML={subtitle}
                >
                  {subtitle}
                </FreeText>
                <Button
                  className={styles.downloadButton}
                  size="normal"
                  onClick={() => navigate('/download')}
                  theme="light"
                >
                  Get the Borderless plan
                </Button>
                <StaticImage
                  src="../images/borderless-card.png"
                  alt="Algbra Borderless Card"
                  layout="constrained"
                  width={464}
                  quality={100}
                  placeholder="none"
                  loading="eager"
                  className={styles.cardImage}
                />
              </div>
              <div className={styles.bottomContainer}>
                <div className={styles.disclaimer}>
                  <InfoIcon />
                  <p className={styles.disclaimerDescription}>
                    This page is provided for informational purposes only and is
                    not intended as marketing or solicitation in jurisdictions
                    where we are not licensed or authorised to operate.
                  </p>
                </div>
              </div>
            </Column>
          </Row>
        </Container>
      </HeaderContainerBorderless>

      {zones && <FeaturesZoneRenderer zones={zones} />}
      <Footer />
    </div>
  )
}

export const pageQuery = graphql`
  query ($id: ID!) {
    strapiGQL {
      feature(id: $id) {
        ...StrapiGQL_FeaturesWithContentZones
      }
    }
  }
`
